































import CourseAppVue from "@/apps/CourseAppVue.vue";
import { Component, Prop } from "vue-property-decorator";

import { CourseSessionStatus, RoleName } from "@/core/constants";
import { SettingsService } from "@/core/services";
import {
    CourseSessionModel,
} from "@/core/models";

@Component({ name: "CourseSessionNavigation" })
export default class CourseSessionNavigation extends CourseAppVue {
    @Prop() courseSession: CourseSessionModel;

    get showNavigation() {
        return this.courseSession.courseSessionId !== undefined;
    }

    get showAttendees() {
        return this.courseSession.courseSessionStatusId >= CourseSessionStatus.Approved;
    }

    get showAttendeesPrerequisites() {
        if (!SettingsService.getShowAttendeesPrerequisites()) {
            return false;
        }

        if (!this.showAttendees) {
            return false;
        }

        if (this.isInRole(RoleName.CourseViewer, true)) {
            return true;
        }

        const organiser = this.courseSession.educators.find(e => e.isOrganiser);
        if (!organiser) {
            return false;
        }

        return organiser.userId === this.currentUserId;
    }

    get isAdminView() {
        return this.$route.query.adminView === "y";
    }

    get attendeesCount() {
        return this.courseSession.attendeeCount;
    }

    getCourseSessionDetailsRoute() {
        return this.isAdminView
            ? this.getRoute("courseSessionEdit")
            : this.getRoute("courseSessionView");
    }

    getCourseSessionAttendeesPrerequisitesRoute() {
        return this.getRoute("courseSessionAttendeesPrerequisites");
    }

    getCourseSessionAttendeesRoute() {
        return this.getRoute("courseSessionAttendees");
    }

    getCourseSessionHistoryRoute() {
        return this.getRoute("courseSessionHistory");
    }

    getCourseSessionMaterialsRoute() {
        return this.getRoute("courseSessionMaterials");
    }

    getAdminViewQueryValue() {
        return this.isAdminView ? "y" : "n";
    }

    getRoute(name: string) {
        const route = {
            name,
            params: {
                id: this.$route.params.id,
                locale: this.courseSession.locale,
            },
            query: {
                adminView: this.getAdminViewQueryValue(),
            },
        };

        return route;
    }

    getActiveindex() {
        return this.$route.name;
    }
}
